import React from 'react';
import styled, { css } from 'styled-components';
import {
  minBreakpointQuery,
  greyColours,
  brandColours,
  brandFonts,
  fontSize,
  standardColours,
} from '../../styles';
import { Button } from '../ui';
import AcceptedPayments from './AcceptedPayments';

const StyledSidebar = styled.aside`
  ${minBreakpointQuery.medium`
    position: sticky;
    top: 20px;
    align-self: start;
  `}
`;

export const Sidebar = ({ showAcceptedPayments, children }) => (
  <StyledSidebar>
    {children}
    {showAcceptedPayments && <AcceptedPayments />}
  </StyledSidebar>
);

const StyledSummary = styled.div`
  padding: 30px;
  border: 1px solid ${greyColours.lightGrey};
  border-radius: 20px;

  ${minBreakpointQuery.large`
    padding: 40px
  `}
`;

export const Summary = ({ children }) => (
  <StyledSummary>{children}</StyledSummary>
);

const StyledSummaryItem = styled.div`
  display: grid;
  grid-template-columns: 90px 1fr;
  gap: 20px;
  margin-bottom: 20px;

  ${minBreakpointQuery.tsmall`
    position: relative;
  `}

  ${minBreakpointQuery.small`
    grid-template-columns: 100px 1fr;
    gap: 30px;
  `}

  ${minBreakpointQuery.large`
    grid-template-columns: 112px 1fr;
    gap: 40px;
  `}
`;

const StyledImage = styled.img`
  margin: 5px 0;
  min-height: 90px;
  min-width: 90px;
  border-radius: 20px;
  object-fit: cover;

  ${minBreakpointQuery.small`
    min-height: 100px;
    min-width: 100px;
  `}

  ${minBreakpointQuery.large`
    min-height: 112px;
    min-width: 112px;
  `}
`;

const StyledDetails = styled.div`
  width: 100%;
`;

const StyledLocation = styled.p`
  color: ${brandColours.quinary};
  ${fontSize(12)};

  ${minBreakpointQuery.large`
    ${fontSize(14)};
  `}
`;

const StyledName = styled.h3`
  margin: 5px 0;
  ${brandFonts.secondary};
  ${fontSize(22)};
  line-height: 1.2;

  ${minBreakpointQuery.small`
    ${fontSize(26)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(30)};
  `}
`;

export const SummaryItem = ({ location, name, imageUrl }) => (
  <StyledSummaryItem>
    {imageUrl && (
      <StyledImage src={imageUrl} alt={name} width={112} height={112} />
    )}
    <StyledDetails>
      {location && <StyledLocation>{location}</StyledLocation>}
      <StyledName>{name}</StyledName>
    </StyledDetails>
  </StyledSummaryItem>
);

const StyledSummaryDetails = styled.ul`
  border-bottom: 1px solid ${greyColours.lightGrey};
`;

export const SummaryDetails = ({ children }) => (
  <StyledSummaryDetails>{children}</StyledSummaryDetails>
);

const StyledSummaryDetail = styled.li`
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    margin-right: 10px;
    color: ${greyColours.darkPurplishGrey};
  }
`;

export const SummaryDetail = ({ children }) => (
  <StyledSummaryDetail>{children}</StyledSummaryDetail>
);

const StyledSummaryTotal = styled.p`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px 0;
  ${fontSize(18)};
`;

export const SummaryTotal = ({ children }) => (
  <StyledSummaryTotal>{children}</StyledSummaryTotal>
);

const StyledSummaryButton = styled(Button)`
  margin-top: 5px;
  height: 55px;
  width: 100%;
  background-color: ${brandColours.tertiary};

  ${({ hide }) => {
    if (hide) {
      return css`
        display: none;
      `;
    } else {
      return css`
        display: block;
      `;
    }
  }}

  ${({ paypal, applePay }) => {
    if (paypal) {
      return css`
        background-color: #ffc43a;
        color: ${standardColours.black};
      `;
    } else if (applePay) {
      return css`
        background-color: ${standardColours.black};
      `;
    }
  }}
`;

export const SummaryButton = ({ children, ...props }) => (
  <StyledSummaryButton {...props}>{children}</StyledSummaryButton>
);
